<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="sass">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap')
#app
  min-height: 100vh
*,body,html
  -moz-osx-font-smoothing: grayscale
  -webkit-font-smoothing: antialiased
  font-size: 16px
  color: #212121
*
  font-family: 'Poppins', sans-serif
  box-sizing: border-box

html, body
  margin: 0
  padding: 0
  min-height: -webkit-fill-available
  overflow-x: hidden
  height: 100%

body
  animation-delay: 0.1s
  animation-duration: 0.1s
  animation-iteration-count: 1
  animation-name: fontfix
  color: $text-color
  font-size: 14px
  min-height: 100vh
  -animation-timing-function: linear
  width: 100%

@media screen and (max-width: 768px)
  #app, body
    min-height: 100%
</style>
